import React, { useState } from "react";
import { Upload, Loader2, ImageOff } from "lucide-react";
import { toast } from "sonner";
import { authFetch } from "../../data/api";
import { optimizeImage } from "../../data/image";

// Reusable image control: preview + upload-to-R2 button + manual URL field.
export function ImageField({ value, onChange, label = "Immagine", logout, ratio = "aspect-[4/3]" }) {
  const [uploading, setUploading] = useState(false);

  const onFile = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setUploading(true);
    try {
      const optimized = await optimizeImage(file);
      const name = (file.name || "foto").replace(/\.[^.]+$/, "") + ".jpg";
      const fd = new FormData();
      fd.append("file", optimized, optimized === file ? file.name || "foto" : name);
      const res = await authFetch("/admin/media", { method: "POST", raw: fd });
      onChange(res.url);
      toast.success("Foto caricata");
    } catch (err) {
      toast.error(err.detail || "Caricamento non riuscito");
      if (err.status === 401 && logout) logout();
    } finally {
      setUploading(false);
      e.target.value = "";
    }
  };

  return (
    <div>
      {label && <label className="block text-[0.62rem] uppercase tracking-[0.18em] text-navy/45 mb-2">{label}</label>}
      <div className="flex gap-4 items-start">
        <div className={`w-28 shrink-0 ${ratio} bg-navy/5 border border-navy/10 overflow-hidden flex items-center justify-center`}>
          {value ? (
            <img src={value} alt="" className="w-full h-full object-cover" />
          ) : (
            <ImageOff size={20} className="text-navy/25" />
          )}
        </div>
        <div className="flex-1 space-y-2">
          <label className="inline-flex items-center gap-2 cursor-pointer border border-navy/20 px-4 py-2.5 text-xs uppercase tracking-[0.15em] text-navy hover:border-gold hover:text-gold transition-colors">
            {uploading ? <Loader2 size={14} className="animate-spin" /> : <Upload size={14} />}
            {uploading ? "Carico…" : "Carica foto"}
            <input type="file" accept="image/*" onChange={onFile} disabled={uploading} className="hidden" />
          </label>
          <input
            value={value || ""}
            onChange={(e) => onChange(e.target.value)}
            placeholder="oppure incolla un URL immagine"
            className="w-full bg-transparent border-b border-navy/15 py-2 text-sm text-navy/80 placeholder:text-navy/30 focus:outline-none focus:border-gold"
          />
        </div>
      </div>
    </div>
  );
}
